import { useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Home from "./home";
import { About, CategoryPage, Collections, Contact, NewArrivals, OffersPage, Privacy, Terms } from "./pages";
import { CartPage, CheckoutPage, OrderSuccessPage } from "./shop";
import Admin from "./admin";
import TrackOrder from "./track";
import { CartProvider } from "./store";
import { FloatingWhatsApp } from "./components/layout";
import { initAnalytics, trackPageView } from "./lib/analytics";

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    initAnalytics().then(trackPageView);
  }, [location.pathname, location.search]);
  return null;
}

const TITLES = {
  "/": "Hyderabad Shopping Mall Nanded | Fashion & Wedding Collection",
  "/collections": "Collections | Hyderabad Shopping Mall Nanded",
  "/offers": "Offers | Hyderabad Shopping Mall Nanded",
  "/new-arrivals": "New Arrivals | Hyderabad Shopping Mall Nanded",
  "/about": "About Us | Hyderabad Shopping Mall Nanded",
  "/contact": "Visit Us / Contact | Hyderabad Shopping Mall Nanded",
  "/privacy": "Privacy Policy | Hyderabad Shopping Mall Nanded",
  "/terms": "Terms & Conditions | Hyderabad Shopping Mall Nanded",
};

function AppRoutes({ lenis }) {
  const location = useLocation();
  useEffect(() => {
    lenis?.current?.scrollTo(0, { immediate: true });
    document.title = TITLES[location.pathname] || "Hyderabad Shopping Mall Nanded | Fashion & Wedding Collection";
  }, [location.pathname, lenis]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/collections" element={<Collections />} />
      <Route path="/collections/:slug" element={<CategoryPage />} />
      <Route path="/offers" element={<OffersPage />} />
      <Route path="/new-arrivals" element={<NewArrivals />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/order-success" element={<OrderSuccessPage />} />
      <Route path="/track" element={<TrackOrder />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default function App() {
  const lenis = useRef(null);

  useEffect(() => {
    const instance = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    lenis.current = instance;
    let raf;
    const loop = (time) => {
      instance.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      instance.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <CartProvider>
        <AnalyticsTracker />
        <AppRoutes lenis={lenis} />
        <FloatingWhatsApp />
        <Toaster position="bottom-center" richColors />
      </CartProvider>
    </BrowserRouter>
  );
}
